<template>
  <Modal v-model="unitsModal" :title="$t('key1003255')" :mask-closable="false" @on-visible-change="unitsChange">
    <div class="flex align-items-start justify-content-around">
      <div>
        <h2 class="font-size-14 color-333 font-weight-bold mb10">{{configCharacters() + $t('key1000480')}}</h2>
        <div class="mb10" v-for="item in attributeUnitList">{{ item.unitValue + ' ' + item.unitName }}</div>
      </div>
      <Icon type="md-repeat" class="mb10" size="22"/>
      <div>
        <h2 class="font-size-14 color-333 font-weight-bold mb10">{{ $t('key1003256') }}</h2>
        <div class="mb10 flex align-items-center" v-for="item in platformAttributeUnitData">
          <InputNumber class="mr8" :max="999999" :min="0" v-model="item.platformAttributeValueRate"
            style="width: 80px;" size="small"></InputNumber>
          <Select v-model="item.platformAttributeValueUnit" style="width: 80px;" size="small">
            <Option v-for="val in platformAttributeValueUnitList" :value="val">{{ val }}</Option>
          </Select>
        </div>
      </div>
    </div>
    <template #footer>
      <Button @click="unitsModal=false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="unitsBtn" :disabled="unitsTalg">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'unitsModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      unitsModal: false,
      attributeUnitList: [],
      platformAttributeUnitData: [],
      platformAttributeValueUnitList: [],
      ymsProductAttributeTemplateId: null,
    };
  },
  computed: {
    unitsTalg() {
      return !this.platformAttributeUnitData.some((item) => item.platformAttributeValueRate && item.platformAttributeValueUnit);
    }
  },
  methods: {
    // 初始化数据
    initUnitsData(row, newList, commonCategoryAttributesData) {
      this.ymsProductAttributeTemplateId = row.id;
      let valueList = [];
      let unitValueList = [];
      let attrList = row.attr || [];
      attrList.map((item) => {
        let value = item.valueList[0].value;
        valueList.push(value);
      });
      this.platformAttributeUnitData = [];
      if (newList.length > 0) {
        newList.map((item) => {
          item.unitName = item.cnValue;
          item.unitValue = 1;
          this.platformAttributeUnitData.push({
            ymsCategoryProductAttributeId: item.ymsCategoryProductAttributeId,
            ymsProductAttributeDictionaryId: item.ymsProductAttributeDictionaryId,
            ymsProductAttributeTemplateId: item.ymsProductAttributeTemplateId,
            platformAttributeValueRate: item.platformAttributeValueRate || null,
            platformAttributeValueUnit: item.platformAttributeValueUnit || null
          });
        });
      }
      if (commonCategoryAttributesData.length > 0) {
        commonCategoryAttributesData.map((ele) => {
          if (valueList.includes(ele.attributeValue)) {
            let unitValue = ele.unitValue;
            if (unitValue) {
              let newUnitValue = unitValue.split(',');
              unitValueList.push(...newUnitValue);
            }
          }
        });
      }
      this.attributeUnitList = newList;
      this.platformAttributeValueUnitList = this.uniqueFunc(unitValueList);
      let platformAttributeUnitList = row.platformAttributeUnitList || [];
      if (platformAttributeUnitList.length > 0) {
        this.platformAttributeUnitData = platformAttributeUnitList;
      }
      this.unitsModal = true;
    },
    // 确定
    unitsBtn() {
      this.$emit('updateUnits', {id: this.ymsProductAttributeTemplateId, platformAttributeUnitList: this.platformAttributeUnitData});
      this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003254'));
      this.unitsModal = false;
    },
    // 监听弹窗
    unitsChange(value) {
      if (!value) {
        this.platformAttributeUnitData = [];
      }
    },
  },
  watch: {},
  components: {}
};
</script>

<style lang="less">

</style>
